import * as React from "react";
import { Path, Rect } from "react-native-svg";
import { Icon, IIconProps } from "native-base";

export const BigFlip = (props: IIconProps) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <Path
      d="M18.449 19.5476C14.1954 20.221 9.86017 20.221 5.60652 19.5476C5.13031 19.4381 4.69118 19.2082 4.33231 18.8804C3.97344 18.5526 3.70719 18.1383 3.55975 17.6782C2.81342 14.5525 2.81342 11.2984 3.55975 8.17272C3.7086 7.71339 3.9753 7.29985 4.33394 6.97229C4.69258 6.64473 5.13097 6.41427 5.60652 6.30331C9.86017 5.62994 14.1954 5.62994 18.449 6.30331C18.9246 6.41427 19.363 6.64473 19.7216 6.97229C20.0803 7.29985 20.347 7.71339 20.4958 8.17272C21.2421 11.2984 21.2421 14.5525 20.4958 17.6782C20.3484 18.1383 20.0821 18.5526 19.7232 18.8804C19.3644 19.2082 18.9252 19.4381 18.449 19.5476V19.5476Z"
      stroke="currentColor"
      fill="transparent"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <Path
      d="M3.95026 11.0499L8.39392 11.0499"
      stroke="currentColor"
      fill="transparent"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <Path
      d="M15.6039 11.0499L20.0475 11.0499"
      stroke="currentColor"
      fill="transparent"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <Path
      d="M8.40167 5.76465C8.61473 5.45778 8.73114 5.07671 8.73188 4.68372C8.73187 4.22484 8.88951 3.78461 9.17035 3.45926C9.45119 3.1339 9.83238 2.94987 10.2306 2.94739H13.6109C13.8088 2.94739 14.0048 2.9923 14.1876 3.07956C14.3704 3.16682 14.5366 3.29472 14.6765 3.45595C14.8164 3.61718 14.9274 3.8086 15.0031 4.01926C15.0789 4.22992 15.1178 4.45571 15.1178 4.68372V4.73065C15.1082 5.14293 15.2269 5.54558 15.4525 5.86577"
      stroke="currentColor"
      fill="transparent"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <Path
      d="M12.1994 16.4515C12.1994 16.5601 12.1113 16.6482 12.0028 16.6482C11.8942 16.6482 11.8062 16.5601 11.8062 16.4515C11.8062 16.343 11.8942 16.2549 12.0028 16.2549C12.1113 16.2549 12.1994 16.343 12.1994 16.4515Z"
      fill="transparent"
      stroke="currentColor"
      strokeWidth="1.40735"
    />
    <Rect
      x="8.40167"
      y="9.24933"
      width="7.20222"
      height="3.60111"
      rx="1.80055"
      stroke="currentColor"
      fill="transparent"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);

export default BigFlip;
